import { render, staticRenderFns } from "./HelloWorld.vue?vue&type=template&id=1ec17a19&scoped=true&"
import script from "./HelloWorld.vue?vue&type=script&lang=js&"
export * from "./HelloWorld.vue?vue&type=script&lang=js&"
import style0 from "./HelloWorld.vue?vue&type=style&index=0&id=1ec17a19&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../layers/paketo-buildpacks_npm-install/build-modules/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec17a19",
  null
  
)

export default component.exports